import Vue from "vue";
export const HttpStatusEventBus = new Vue();
export default HttpStatusEventBus;
